import getHostVariables from './getHostVariables';
import {PROPS} from '../symbols';
import {get} from '@servicenow/ui-internal';

export default function selectablePropertyResolver(componentRegistry, id, name, path) {
	const el = componentRegistry[id];
	if (el) {
		const hostVariables = getHostVariables(el);
		const property = hostVariables[PROPS][name];
		if (path) {
			return property && property[0] === '@'
				? path[0] === '['
					? `${property}${path}`
					: `${property}.${path}`
				: get(property, path);
		}

		return property;
	}

	return undefined;
}
